export default "__VITE_ASSET__987bd140__"